import React, { useRef } from "react";
import { useTranslation } from "react-i18next";

const PasswordValidation = ({ errors, watch, requirePassword, register }) => {
  const { t } = useTranslation();
  const password = useRef({});
  password.current = watch("password", "");

  return (
    <div id="password">
      <div className="field-wrapper">
        <div className="inputs">
          <label htmlFor="password" className="label">
            {t("password.password_label")}
            {requirePassword ? "*" : ""}
          </label>
          <input
            type="password"
            id="password"
            name="password"
            {...register("password", {
              required: requirePassword && t("password.enter_password_required"),
            })}
            data-cy="password"
          />
          <div className="clear" />
        </div>
        {errors.password && (
          <p className="errorlist" data-cy="error-password">
            {errors.password.message}
          </p>
        )}
      </div>
      <div className="field-wrapper">
        <div className="inputs">
          <label htmlFor="confirm_password" className="label">
            {t("password.confirm_password_label")}
            {requirePassword ? "*" : ""}
          </label>
          <input
            type="password"
            id="confirm_password"
            name="confirm_password"
            data-cy="confirm_password"
            {...register("confirm_password", {
              validate: (value) => value === password.current || t("password.passwords_do_not_match"),
            })}
          />
          <div className="clear" />
        </div>
        {errors.confirm_password && (
          <p className="errorlist" data-cy="error-password">
            {" "}
            {errors.confirm_password.message}
          </p>
        )}
      </div>
    </div>
  );
};

export default PasswordValidation;
